import { FC, useEffect } from 'react';
import { urlParams } from '@lhb/func';
import * as dd from 'dingtalk-jsapi';
import { useMethods } from '@lhb/hook';
import { post } from '@/common/request';
import { setCookie } from '@lhb/cache';
import { Spin } from 'antd';
import styles from './entry.module.less';

const DingLogin: FC<{}> = () => {
  const { corpId } = urlParams(location.search);

  useEffect(() => {
    const platform = dd.env.platform;
    if (platform === 'pc') {
      methods.dingLogin();
    }
  }, []);

  const methods = useMethods({
    dingLogin: () => {

      dd.requestAuthCode({
        corpId: corpId,
        clientId: 'suite2btnqo41snsqiffs',
        onSuccess: (result) => {
          // setCode(JSON.stringify(result));
          // message.success(`onSuccess: ${JSON.stringify(result)} === corpId: ${corpId}`);
          // console.log('result', result);
          const params = { code: result?.code, corpId };

          // https://yapi.lanhanba.com/project/378/interface/api/78000
          post('/dingTalkOauth/login', params, { isMirage: true }).then((res) => {
            const { token, employeeId, tenantId } = res;
            tenantId && setCookie('tenantId', tenantId);
            employeeId && setCookie('employeeId', employeeId);
            token && setCookie('flow_token', token);
            // 刷新页面
            setTimeout(() => {
              window.location.href = '/';
            }, 100);
          }).catch(() => {
            // message.success(`yapi:chucuowl`);
          }).finally(() => {
            // message.success(`yapi: 结果`);
          });
        },
        onFail: (err) => {
          // setErr('requestAuthCode fail: ' + JSON.stringify(err));
          console.log('requestAuthCode fail: ' + JSON.stringify(err));
        },
        complete: (res) => {
          console.log('requestAuthCode complete: ' + JSON.stringify(res));

        }
      });
    }
  });


  return (
    <div className={styles.container}>
      <Spin size='large' tip='登录中...'/>
    </div>
  );
};

export default DingLogin;
